<template>
  <form @submit.prevent="save()">
    <text-input v-model="title" :config="{ label: $t('linkcreation.title') }"></text-input>
    <text-input v-model="url" :config="{ type: 'url', label: $t('linkcreation.url'), required: true }"></text-input>
    <v-btn primary light block :loading="loading" type="submit">{{ $t('linkcreation.save') }}</v-btn>
  </form>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import { TextInput } from '@/components/inputs'
  export default {
    components: {
      TextInput
    },
    data () {
      return {
        title: '',
        url: ''
      }
    },
    computed: mapGetters({
      loading: 'skiliko/links/isLoading'
    }),
    methods: {
      ...mapActions({
        saveLink: 'skiliko/links/save'
      }),
      save () {
        this.loading = true
        this.saveLink({ data: {
          title: this.title,
          url: this.url
        } })
          .then(link => {
            this.$emit('saved', link)
            this.loading = false
          })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/LinkCreation.vue